<p *ngIf="!article">Betöltés...</p>

<article *ngIf="article">
  <p class="admin-tools text-right mb-4"
     *ngIf="auth.hasAnyRoleOf('admin', 'publisher')"
  >
    <a [routerLink]="['/admin/tartalmak', article.id, 'modositas']"
       class="btn btn-outline-primary"
    ><i class="fa fa-pencil"></i> Módosítás</a>
  </p>
  <h2>{{article.title}}</h2>
  <h6>{{article.subtitle}}</h6>
  <div [innerHTML]="article.message"></div>
</article>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/contents/article-item/article-item.component.html